import { render, staticRenderFns } from "./DropFile.vue?vue&type=template&id=81e25d2e&scoped=true&"
import script from "./DropFile.vue?vue&type=script&lang=ts&"
export * from "./DropFile.vue?vue&type=script&lang=ts&"
import style0 from "./DropFile.vue?vue&type=style&index=0&id=81e25d2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e25d2e",
  null
  
)

export default component.exports